import { configureStore } from '@reduxjs/toolkit';
import servicesReducer from './slices/servicesSlice';
import configReducer from './slices/configSlice';
import discoveryReducer from './slices/discoverySlice';
import userReducer from './slices/userSlice';

declare global {
    interface Window {
        __PRELOADED_STATE__?: any; // eslint-disable-line @typescript-eslint/no-explicit-any
    }
}

const preloadedState = typeof window !== 'undefined' ? window.__PRELOADED_STATE__ : undefined;

if (typeof window !== 'undefined') {
    delete window.__PRELOADED_STATE__;
}

export const store = configureStore({
    reducer: {
        services: servicesReducer,
        config: configReducer,
        discovery: discoveryReducer,
        user: userReducer,
    },
    preloadedState,
});

export type ReduxState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
